// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Xero Sync Status Styles */

.xero-sync-status {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.sync-statistics,
.sync-progress,
.sync-actions,
.sync-errors,
.sync-info {
  background: rgb(57, 122, 124);
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.sync-statistics h3,
.sync-progress h3,
.sync-actions h3,
.sync-errors h3,
.sync-info h3 {
  margin: 0 0 20px 0;
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
}

.sync-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 16px;
}

.sync-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  text-align: center;
}

.stat-label {
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
}

.stat-value.synced {
  color: #166534;
}

.stat-value.pending {
  color: #d97706;
}

.stat-value.failed {
  color: #dc2626;
}

.stat-value.not-synced {
  color: #6b7280;
}

/* Progress Bar */
.progress-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.progress-bar {
  width: 100%;
  height: 12px;
  background: #e2e8f0;
  border-radius: 6px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
  border-radius: 6px;
  transition: width 0.3s ease;
}

.progress-text {
  text-align: center;
  font-weight: 500;
  color: #64748b;
  font-size: 14px;
}

/* Actions */
.actions-grid {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.btn {
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-primary {
  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
  color: white;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.btn-warning {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
}

.btn-warning:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* Sync Errors */
.error-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.error-item {
  padding: 16px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  border-left: 4px solid #dc2626;
}

.error-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.error-type {
  font-weight: 600;
  color: #991b1b;
  font-size: 14px;
}

.error-time {
  font-size: 12px;
  color: #b91c1c;
}

.error-message {
  color: #7f1d1d;
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 8px;
}

.error-details {
  color: #991b1b;
  font-size: 12px;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  background: #fee2e2;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #fecaca;
}

/* Sync Info */
.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.info-label {
  font-weight: 500;
  color: #64748b;
  font-size: 14px;
}

.info-value {
  font-weight: 600;
  color: #1e293b;
  font-size: 14px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .sync-stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .actions-grid {
    flex-direction: column;
  }

  .info-grid {
    grid-template-columns: 1fr;
  }

  .error-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/xero/XeroSyncStatus.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;;;;EAKE,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;;;;;EAKE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,wDAAwD;EACxD,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;AACF","sourcesContent":["/* Xero Sync Status Styles */\n\n.xero-sync-status {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.sync-statistics,\n.sync-progress,\n.sync-actions,\n.sync-errors,\n.sync-info {\n  background: rgb(57, 122, 124);\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.sync-statistics h3,\n.sync-progress h3,\n.sync-actions h3,\n.sync-errors h3,\n.sync-info h3 {\n  margin: 0 0 20px 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.sync-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 16px;\n}\n\n.sync-stat {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 16px;\n  background: #f8fafc;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  text-align: center;\n}\n\n.stat-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 8px;\n}\n\n.stat-value {\n  font-size: 24px;\n  font-weight: 700;\n  color: #1e293b;\n}\n\n.stat-value.synced {\n  color: #166534;\n}\n\n.stat-value.pending {\n  color: #d97706;\n}\n\n.stat-value.failed {\n  color: #dc2626;\n}\n\n.stat-value.not-synced {\n  color: #6b7280;\n}\n\n/* Progress Bar */\n.progress-container {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.progress-bar {\n  width: 100%;\n  height: 12px;\n  background: #e2e8f0;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n  border-radius: 6px;\n  transition: width 0.3s ease;\n}\n\n.progress-text {\n  text-align: center;\n  font-weight: 500;\n  color: #64748b;\n  font-size: 14px;\n}\n\n/* Actions */\n.actions-grid {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.btn {\n  padding: 12px 20px;\n  border: none;\n  border-radius: 8px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n  color: white;\n}\n\n.btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n}\n\n.btn-warning {\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n  color: white;\n}\n\n.btn-warning:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Sync Errors */\n.error-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.error-item {\n  padding: 16px;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  border-left: 4px solid #dc2626;\n}\n\n.error-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.error-type {\n  font-weight: 600;\n  color: #991b1b;\n  font-size: 14px;\n}\n\n.error-time {\n  font-size: 12px;\n  color: #b91c1c;\n}\n\n.error-message {\n  color: #7f1d1d;\n  font-size: 14px;\n  line-height: 1.5;\n  margin-bottom: 8px;\n}\n\n.error-details {\n  color: #991b1b;\n  font-size: 12px;\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n  background: #fee2e2;\n  padding: 8px;\n  border-radius: 4px;\n  border: 1px solid #fecaca;\n}\n\n/* Sync Info */\n.info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n}\n\n.info-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px;\n  background: #f8fafc;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n}\n\n.info-label {\n  font-weight: 500;\n  color: #64748b;\n  font-size: 14px;\n}\n\n.info-value {\n  font-weight: 600;\n  color: #1e293b;\n  font-size: 14px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .sync-stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .actions-grid {\n    flex-direction: column;\n  }\n\n  .info-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .error-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
